import * as React from 'react';
import { inject, observer } from 'mobx-react';

export default function NameRenderer(
    store: string,
    nameRedirect?: (obj: any) => JSX.Element,
    find: (v: any, i: any) => boolean = ( (v, o) => o.typedId === v)
    
) {
    return inject(store) (
        observer (
            class Namer extends React.Component<any> {
    
                render() {
                    const items = this.props[store].getParsedItems;
                    let result = undefined;
                    const _find = find.bind(this, this.props.value);
                    if (items && items.find) {
                        const item = items.find(_find);
                        if (item) {
                            result = item;
                        }
                    } 
                    if (nameRedirect) {
                        result = nameRedirect(result);
                    } else {
                        result = (result || {}).name  || 'Unknown';
                    }

                    return <div> {result} </div>;
                }
            }
        )
    );
}


// WEBPACK FOOTER //
// ./src/container/Generic/Namer.tsx